module.exports = __webpack_public_path__ + "64c4108b7211e2356f9258b35aaee81d.svg";